export default async ({ store, redirect }) => {
  if (store.state.global.user.membership === null) {
    redirect('/product');
  }
};
